import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ECPA_RULES } from '@/utils/constants';

@Component({
    name: 'reroute-rules',
})

export default class RerouteRules extends Vue {

    // ----------------------------------------------------------------
    // Properties

    @Prop()
    private suggestedItems: any;

    private allRules: any = [];

    private rerouteRules: any = [
        {
            name: 'ECpA Rules',
            keyName: 'ecpa-rule',
            contents: ['Rule 1 [w1]', 'Rule 6[w6]', 'Rule 8 [w8]'],
        },
        {
            name: 'Principles of Learning',
            keyName: 'principle',
            contents: ECPA_RULES,
        },
        {
            name: 'Resource Score & Ranking',
            keyName: 'resource',
            contents: [
                {
                    name: 'Web resource',
                    count: 0.8,
                },
                {
                    name: 'Audio resource',
                    count: 0.6,
                },
                {
                    name: 'Video resource',
                    count: 0.5,
                },
                {
                    name: 'Text resource',
                    count: 0.7,
                },
            ],
        },

    ];

    @Watch('suggestedItems')
    private onChangeSuggestion() {
        this.onLoadRules();
    }

    // ---------------------------------------------------------------
    // Hooks

    private created() {
        this.onLoadRules();
    }

    // ---------------------------------------------------------------
    // Methods

    private onLoadRules() {
        const suggestedItems = this.suggestedItems;
        const resourceItems: any = [];
        const ruleItems: any = [];
        const principleItems: any = [];
        suggestedItems.forEach((item: any) => {
            const contents = item.contents || [];
            const resouceContent = contents[0];
            const title = resouceContent ? resouceContent.title : item.title;
            let label = resouceContent ? resouceContent.subFormat : item.format;
            label = label.split('_').join(' ');
            const resource = {
                score: item.score.toFixed(2),
                label,
                format: item.format,
                title,
            };
            const existingRuleItems = ruleItems.find((items: any) => items === item.actionId);
            if (!existingRuleItems) {
              ruleItems.push(item.actionId);
            }

            const action: any = item.actionId.split('-');
            if (action && action[1]) {
              const existingPrincipleItems = principleItems.find((items: any) => items === action[1]);
              if (!existingPrincipleItems) {
                principleItems.push(action[1]);
              }
            }
            resourceItems.push(resource);
        });
        const resourceMenu = this.rerouteRules.find((item: any) => item.keyName === 'resource');
        const ecpaMenu = this.rerouteRules.find((item: any) => item.keyName === 'ecpa-rule');
        const principleMenu = this.rerouteRules.find((item: any) => item.keyName === 'principle');

        const allRule: any = [];
        principleItems.map( (list: any, index: any) => {
          const rule: any = ECPA_RULES.find((item: any) => item.rule_id === list);
          allRule.push(rule);
        });
        this.allRules = allRule;
        principleMenu.contents = allRule;
        resourceMenu.contents = resourceItems;
        ecpaMenu.contents = ruleItems;
    }

}
